import { Service, ControllerService, Controller, ToolbarService } from '@tencent/workbench';
import { FIXED_KEYS_DOUBLE } from '../../schema/constant';
import _debounce from 'lodash/debounce';
import { getController, getToolBarSchema, getToolBarConfig } from '@src/js/common/ark-extensions/dc-components/template-machine-audit';

/**
 * 机器审核核心服务层
 */
@Service()
export class MachineAuditService {
    private debounceUpdate = _debounce(() => {
        this.toolbarService.$forceUpdate();
    });

    public constructor(
        private controllerService: ControllerService,
        private readonly toolbarService: ToolbarService,
    ) {}

    /**
     * 根据当前的 schema/config 后，重新构建并注册 controller，
     */
    public async updateController() {
        const schema = this.toolbarService.getSchema();
        if (schema[FIXED_KEYS_DOUBLE.TOOLBAR_MACHINE_AUDIT]) {
            // 动态从 dc 组件拉取 schema
            schema[FIXED_KEYS_DOUBLE.TOOLBAR_MACHINE_AUDIT] = await getToolBarSchema();
        } else {
            return;
        }
        this.toolbarService.setSchema(schema);

        // 重新更新 workbench
        const controller = await getController();
        Controller({ toolbarItems: await getToolBarConfig() })(controller);
        this.controllerService.buildController(controller);
        this.debounceUpdate();
    }
}
